export default "__VITE_ASSET__CPRXGfgO__"